module.exports = "/_next/static/images/attorney-katona-d6ad5e362fcb19df092b0af176264cdc.png";